var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('keep-alive',{attrs:{"include":"Map"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }